// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import contactanos from "assets/images/contactanos.jpg"

function Contactanos() {

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox minHeight="30vh"></MKBox>
      <Card
        minHeight="30vh"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                Contactanos
              </MKTypography>
              <MKTypography variant="h3" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                Contáctanos y cotiza tu bomba o tus refacciones
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                En ARES ofrecemos una amplia gama de tecnologías y soluciones de equipos de bombeo para cumplir y superar los requisitos de una gran variedad de aplicaciones dentro de diversos mercados. Contáctanos y platiquemos de tus necesidades, especificaciones e instalaciones.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Nuestros equipos de bombeo cumplen con los estándares de la industria más exigentes.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Si estás buscando equipos de bombeo de marcas reconocidas o equipos genéricos con la misma calidad, te ofrecemos ambos. Tan sólo contáctanos.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <MKBox component="section" py={{ xs: 0, lg: 6 }}>
            <Container>
                <Grid container item>
                <MKBox
                    width="100%"
                    bgColor="white"
                    borderRadius="xl"
                    shadow="xl"
                    mb={6}
                    sx={{ overflow: "hidden" }}
                >
                    <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        lg={5}
                        position="relative"
                        px={0}
                        sx={{
                        backgroundImage: ({
                            palette: { gradients },
                            functions: { rgba, linearGradient },
                        }) =>
                            `${linearGradient(
                            rgba(gradients.dark.main, 0.8),
                            rgba(gradients.dark.state, 0.8)
                            )}, url(${contactanos})`,
                        backgroundSize: "cover",
                        }}
                    >
                        <MKBox
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            width="100%"
                            height="100%"
                        >                            
                        </MKBox>
                    </Grid>
                    <Grid item xs={12} lg={7}>
                        <MKBox component="form" p={2} method="post">
                        <MKBox px={3} py={{ xs: 2, sm: 6 }}>
                            <MKTypography variant="h2" mb={1}>
                                Datos de contacto
                            </MKTypography>
                            <MKTypography variant="body1" color="text" mb={2}>
                                Por favor llena el formulario
                            </MKTypography>
                        </MKBox>
                        <MKBox pt={0.5} pb={3} px={3}>
                            <Grid container>
                            <Grid item xs={12} md={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Nombre"
                                    placeholder="Nombre"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Apellido"
                                    placeholder="Apellido"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Correo"
                                    placeholder="Correo"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Teléfono"
                                    placeholder="Teléfono"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Estado"
                                    placeholder="Estado"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Empresa"
                                    placeholder="Empresa"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Tipo de bomba"
                                    placeholder="Tipo de bomba"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Marca / Modelo"
                                    placeholder="Marca / Modelo"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            </Grid>
                             <Grid item xs={12} pr={1} mb={6} style={{padding: "10px"}}>
                                <MKInput
                                    variant="standard"
                                    label="Comentarios"
                                    placeholder="Comentarios"
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    multiline
                                    rows={4}
                                />
                            </Grid>
                            </Grid>
                            <Grid
                            container
                            item
                            xs={12}
                            md={6}
                            justifyContent="flex-end"
                            textAlign="right"
                            ml="auto"
                            >
                            <MKButton variant="gradient" color="info">
                                Envíar
                            </MKButton>
                            </Grid>
                        </MKBox>
                        </MKBox>
                    </Grid>
                    </Grid>
                </MKBox>
                </Grid>
            </Container>
        </MKBox>
      </Card>
      <MKBox px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Contactanos;
